import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { PiSealQuestionBold } from "react-icons/pi";
import SuccessModal from "./successModal/SuccessModal";
import { submitAnswers } from "../../../services/submitQuestions";

const Questions = ({ quizData }) => {
  console.log("========?qiouestionData", quizData);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAnswer = (id) => {
    setAnswers({ ...answers, [currentQuestion]: id });
    if (currentQuestion < quizData.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const handleSkip = () => {
    setAnswers({ ...answers, [currentQuestion]: null });
    if (currentQuestion < quizData.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };
  const handlePrev = () => {
    setCurrentQuestion(currentQuestion - 1);
  };

  const handleSubmit = async () => {
    // setIsModalOpen(true);
    try {
      const submission = Object.keys(answers).map((key) => ({
        questionId: quizData[key]?.id,
        answerKey: answers[key],
      }));

      const payload = JSON.stringify({ submission });
      console.log(payload); // Debugging purpose

      await submitAnswers(payload); // Pass the correct JSON string
      setIsModalOpen(true);
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const progress = ((currentQuestion + 1) / quizData.length) * 100;

  return (
    <div className="w-full mx-auto pt-10 md:px-20 bg-white">
      {/* Progress Bar */}
      <div className="w-full bg-gray-200 h-2.5 rounded-full mb-6">
        <div
          className="h-2.5 bg-yellow-500 rounded-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      {currentQuestion >= 0 &&
      currentQuestion !== quizData.length - 1 &&
      currentQuestion !== quizData.length ? (
        <div className="mt-3 flex justify-between">
          {currentQuestion > 0 ? (
            <Link
              onClick={handlePrev}
              className="px-4 py-2 font-semibold gap-2 md:mb-3 text-black flex items-center justify-between"
            >
              <FaArrowLeftLong />
            </Link>
          ) : (
            <>
              <Link className="px-4 py-2 font-semibold gap-2 md:mb-3 text-black flex items-center justify-between"></Link>
            </>
          )}

          <button
            onClick={handleSkip}
            className="px-4 py-2 font-semibold md:mb-3 text-black gap-2 flex items-center justify-between"
          >
            <FaArrowRightLong />
          </button>
        </div>
      ) : currentQuestion === quizData.length - 1 ||
        currentQuestion === quizData.length ? (
        <div className="mt-3 flex justify-between">
          <Link
            onClick={handlePrev}
            className="px-4 py-2 font-semibold gap-2 md:mb-3 text-black flex items-center justify-between"
          >
            <FaArrowLeftLong />
          </Link>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 font-semibold md:mb-3 text-black gap-2 flex items-center justify-between"
          >
            <FaArrowRightLong />
          </button>
        </div>
      ) : (
        <div className="mt-3 flex justify-between">
          <Link
            onClick={handlePrev}
            className="px-4 py-2 font-semibold gap-2 md:mb-3 text-black flex items-center justify-between"
          >
            <FaArrowLeftLong />
          </Link>
        </div>
      )}

      <div className="md:flex gap-5 items-start w-full justify-center px-5 md:pl-0 md:justify-center">
        {quizData?.length <= 0 ? (
          <div>
            <h2 className="text-2xl md:text-3xl text-gray-800 font-semibold mt-2 md:-mt-6 mb-4 flex gap-2 items-center justify-start">
              Sorry no questions available
            </h2>
          </div>
        ) : (
          <div className="md:w-[45rem] md:px-5">
            {/* <h2 className="text-2xl md:text-3xl text-gray-800 font-semibold mt-2 md:-mt-6 mb-4 flex gap-2 items-center justify-start">
              Tables Curated Just for You
            </h2> */}
            <h2 className="text-lg w-full md:text-2xl text-gray-700 font-semibold mb-4 flex gap-2 items-center justify-start">
              <PiSealQuestionBold size={28} className="hidden md:inline" />
              <span className="md:hidden"> Q. &nbsp;</span>
              {quizData[currentQuestion]?.question}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {quizData[currentQuestion]?.options.map((option) => (
                <div
                  key={option?.id}
                  onClick={() => handleAnswer(option?.id)}
                  className={`w-full p-3 border rounded-2xl text-sm md:text-base text-gray-600 cursor-pointer text-left transition-all border-2 border-[#e2b760] duration-300 ${
                    quizData[currentQuestion]?.answer_key === option?.id ||
                    (answers[currentQuestion] === option?.id &&
                      !quizData[currentQuestion]?.answer_key)
                      ? "bg-[#e2b760] text-white border-2 border-[#e2b760]"
                      : "border-[#e2b760] hover:bg-[#e2b760] hover:text-white"
                  }`}
                >
                  {option?.text}
                </div>
              ))}
            </div>

            {currentQuestion === quizData.length - 1 && (
              <div
                onClick={handleSubmit}
                className="w-full p-3 md:w-72 mt-8 bg-black border rounded-2xl text-sm md:text-base text-gray-100 cursor-pointer 
                text-left transition-all text-center duration-300"
              >
                Submit Response
              </div>
            )}
          </div>
        )}
      </div>

      <SuccessModal setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />
    </div>
  );
};

export default Questions;
